import {
    GateHeading,
    GateSubcopy,
} from '~/modules-rocco/user/component/auth-modal/GateHeading';

interface StepTextProps {
    children: React.ReactNode;
}

/**
 * The wizard speaks the auth modal's type scale — the whole flow lives in the
 * shared two-pane shell, so its steps and the gate's steps must read as one
 * sequence. Thin wrappers rather than direct imports, so a wizard-wide type
 * change stays a one-file edit.
 */
export const StepHeading = ({ children }: StepTextProps) => {
    return <GateHeading>{children}</GateHeading>;
};

/** The supporting line under a step's title. */
export const StepHelperText = ({ children }: StepTextProps) => {
    // The step containers own the vertical rhythm through their gap, so the
    // subcopy's built-in offset would double it.
    return <GateSubcopy className="mt-0">{children}</GateSubcopy>;
};
